module.exports = __webpack_public_path__ + "img/Menu-12.e1661819.png";